<template>
  <div class="popup-holder">
    <div>
      <div class="header">
        {{title}}
        <button @click="$emit('close-popup')">
          <img :src="require(`@/assets/icons/close.svg`)" alt />
        </button>
      </div>
      <div class="content">
        <div>
          <img :src="require(`@/assets/${image}`)" alt />
        </div>
        <div class="text" v-html="text"></div>
      </div>
      <button class="close" @click="$emit('close-popup')">Close</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    image: String,
    text: String,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.header {
  background-image: url("~@/assets/neighborhood/popup-header.jpg");
  background-size: cover;
  height: 100px;
  line-height: 100px;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  text-transform: uppercase;
  position: relative;
  button {
    position: absolute;
    right: 0;
    top: 0;
    padding: 40px 27px;
    cursor: pointer;
  }
}
.close {
  background: rgba(0, 48, 135, 0.8);
  border: 3px solid #ffffff;
  max-width: 200px;
  width: 100%;
  text-transform: uppercase;
  padding: 12px;
  box-sizing: border-box;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  cursor: pointer;
}
.content {
  display: flex;
  padding: 50px;
  width: 100%;
  box-sizing: border-box;
  img {
    margin-right: 50px;
  }
  > div {
    flex-grow: 1;
    text-align: left;
  }
}
.popup-holder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(5, 17, 42, 0.8);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    max-width: 1080px;
    width: calc(100vw - 50px);
    background: #fff;
    > div {
      overflow: auto;
      max-height: calc(100vh - 200px);
    }
  }
}
@media (max-width: 850px) {
  .popup-holder {
    .content {
      flex-direction: column;
      img {
        width: 100%;
      }
      .text {
        margin-top: 25px;
      }
    }
  }
}
</style>